import { render, staticRenderFns } from "./QuestionnaireStatus.vue?vue&type=template&id=95aedff2&scoped=true"
import script from "./QuestionnaireStatus.vue?vue&type=script&lang=js"
export * from "./QuestionnaireStatus.vue?vue&type=script&lang=js"
import style0 from "./QuestionnaireStatus.vue?vue&type=style&index=0&id=95aedff2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95aedff2",
  null
  
)

export default component.exports